import { useRef } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { DownloadSimple, UploadSimple } from "@phosphor-icons/react";

export default function CustomerCsvIO({ onImported }) {
  const inputRef = useRef(null);

  const download = async () => {
    try {
      const res = await api.get("/customers/export", { responseType: "blob" });
      const blob = new Blob([res.data], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `customers-${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Export ready");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const { data } = await api.post("/customers/import", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const msg = `Imported ${data.imported}, skipped ${data.skipped}`;
      if (data.errors?.length) {
        toast.warning(`${msg}. First issue: ${data.errors[0]}`);
      } else {
        toast.success(msg);
      }
      onImported?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        accept=".csv"
        onChange={upload}
        className="hidden"
        data-testid="csv-import-input"
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        data-testid="csv-import-button"
        className="px-3 py-2 border border-canvas-line text-sm hover:border-ink flex items-center gap-1.5"
      >
        <UploadSimple size={13} weight="bold" />
        Import CSV
      </button>
      <button
        type="button"
        onClick={download}
        data-testid="csv-export-button"
        className="px-3 py-2 border border-canvas-line text-sm hover:border-ink flex items-center gap-1.5"
      >
        <DownloadSimple size={13} weight="bold" />
        Export CSV
      </button>
    </div>
  );
}
